import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@/i18n/types'

export type AdFreeDestinationKind = 'try_now' | 'try_confirm' | 'invitation'

function decodePath(pathname: string): string {
  try {
    return decodeURIComponent(pathname)
  } catch {
    return pathname
  }
}

function stripLocalePrefix(path: string): string {
  for (const locale of SUPPORTED_LOCALES) {
    if (locale === DEFAULT_LOCALE) {
      continue
    }
    const prefix = `/${locale}`
    if (path === prefix) {
      return '/'
    }
    if (path.startsWith(`${prefix}/`)) {
      return path.slice(prefix.length)
    }
  }
  return path
}

function isInvitationLink(path: string, search: string): boolean {
  if (path === '/app/workspace/invite' || path.startsWith('/app/workspace/invite/')) {
    return true
  }
  if (path.startsWith('/claim/')) {
    return true
  }
  if (path === '/app/auth/personality-request') {
    return true
  }
  return path.startsWith('/app/') && Boolean(new URLSearchParams(search).get('invite_token'))
}

export function adFreeDestinationKind(
  pathname: string,
  search: string
): AdFreeDestinationKind | null {
  const path = decodePath(pathname)
    .replace(/\/{2,}/g, '/')
    .toLowerCase()
  const rest = stripLocalePrefix(path)
  if (rest === '/try/confirm' || rest.startsWith('/try/confirm/')) {
    return 'try_confirm'
  }
  if (isInvitationLink(path, search)) {
    return 'invitation'
  }
  if (rest === '/try' || rest === '/try/') {
    return 'try_now'
  }
  return null
}

export function documentCarriesGoogleTag(doc: Document = document): boolean {
  return doc.querySelector('script[src^="https://www.googletagmanager.com/"]') !== null
}
